import { useState, useContext } from "react";
import { isMobile } from "react-device-detect";

import logoOn from "../../assets/images/landing/logo-black.svg";
import logoOnMobile from "../../assets/images/landing/logo-black-mobile.svg";
import logoOff from "../../assets/images/landing/logo-white.svg";
import logoOffMobile from "../../assets/images/landing/logo-white-mobile.svg";

import sellIcon from "../../assets/images/ic_tab_sell.svg";
import blogIcon from "../../assets/images/ic_tab_blog.svg";
import lotsIcon from "../../assets/images/ic_tab_lots.svg";
import profileIcon from "../../assets/images/ic_tab_profile.svg";

import avatarProfile from "../../assets/images/placeholder_avatar.jpeg";

import { Link } from "react-router-dom";
import { concatQueryParams, goTo } from "../../utils/global";
import externalLinks from "../../externalLinks";
import Cookies from "js-cookie";

import * as AnalyticsService from '../../services/Analytics';
import PublishModal from "../../components/modals/publish";

import { ModalContext } from '../../context/modal';
import LoginModal from '../../components/login';
import PublishLoggedModal from "../../components/modals/publish-logged";

const NavBar = ({
  className,
  mode,
  buttons,
  isLoggedIn,
  user,
}: {
  className?: string,
  mode?: string,
  buttons?: boolean,
  isLoggedIn?: boolean,
  user?: any,
}) => {
  const [scrollY, setScrollY] = useState<number>(0);
  const [scrollUp, setScrollUp] = useState<boolean>(false);
  const startButton = document.getElementById("start-button");

  const isInStartPosition = () =>
    startButton
      ? startButton.offsetHeight + startButton.offsetTop > window.pageYOffset
      : true;

  const handleScroll = () => {
    const scrollYValue = window.scrollY;
    if (scrollYValue > 0 && scrollY > scrollYValue) {
      setScrollUp(true);
    } else {
      setScrollUp(true);
    }
    setScrollY(scrollYValue);
  };

  const srcLogo = () => {
    if (mode == "WhiteWithShadow") {
      if (isMobile) {
        return logoOnMobile;
      } else {
        return logoOn;
      }
    }
    if (isMobile) {
      if (isInStartPosition()) {
        return logoOffMobile;
      } else {
        return logoOnMobile;
      }
    } else {
      if (isInStartPosition()) {
        return logoOff;
      } else {
        return logoOn;
      }
    }
  };

  const {
    isOpen: modalIsOpen,
    setOpen: modalSetOpen,
    isLoginOpen: loginModalIsOpen,
    setLoginOpen: loginModalSetOpen,
  } = useContext(ModalContext);

  window.addEventListener("scroll", handleScroll);

  const [showCollapse, setShowCollapse] = useState<boolean>(false);
  const [confirmAction, setConfirmAction] = useState<boolean>(false);

  const showCollapseNavbar = () => setShowCollapse(!showCollapse);

  const action = () => {
    loginModalSetOpen(false);
    setConfirmAction(true);
  };

  const nextActionPublished = () => {
    modalSetOpen(false);
    setConfirmAction(true);
  };

  const goToStart = () => {
    AnalyticsService.sendFacebookInformation();
    if (isLoggedIn) {
      modalSetOpen(true);
    } else {
      loginModalSetOpen(true);
    }
  };

  return (
    <>
      <LoginModal modalIsOpen={loginModalIsOpen} nextAction={!isLoggedIn && action} closeModal={() => loginModalSetOpen(false)} classname="login-modal" />
      {isLoggedIn && <PublishLoggedModal modalIsOpen={modalIsOpen} nextAction={nextActionPublished} closeModal={() => modalSetOpen(false)} />}
      {confirmAction && <PublishModal goFinishStep={true} modalIsOpen={confirmAction} closeModal={() => setConfirmAction(false)} />}
      <nav
        className={`navbar navbar-expand-lg ${
          mode != "WhiteWithShadow"
            ? isInStartPosition()
              ? "top"
              : "fixed"
            : "WhiteWithShadow"
        } ${className!}`}
      >
        <div className="container">
          <div className="row">
            <div className="logo">
              <a className="nav-link active" aria-current="page" href="/">
                <img src={srcLogo()} alt="logo campo mercado" />
              </a>
            </div>
            {!isInStartPosition() && (
              <div className="empezar">
                <button
                  className="btn-primary"
                  onClick={() => goToStart()}
                >
                  Empezar
                </button>
              </div>
            )}
            {buttons && (
              <>
                <div className="menu-button">
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarTogglerCM"
                    aria-controls="navbarScroll"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    onClick={() => showCollapseNavbar()}
                  >
                    <i
                      className={`fas ${showCollapse ? "fa-times" : "fa-bars"}`}
                    ></i>
                  </button>
                </div>
                <ul className="menu navbar-nav me-auto mb-2 mb-lg-0">
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      aria-current="page"
                      href={concatQueryParams(externalLinks.lots)}
                    >
                      Lotes
                    </a>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" aria-current="page" to="/venta">
                      Publicar
                    </Link>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      aria-current="page"
                      href={concatQueryParams(externalLinks.blog)}
                    >
                      Blog
                    </a>
                  </li>
                  {!isLoggedIn && (
                    <>
                    <li className="nav-item">
                      <button
                        className="nav-link"
                        style={{
                          border: 'none',
                          background: 'transparent',
                          color: 'black',
                        }}
                        onClick={() => modalSetOpen(true)}
                      >
                        Ingresar
                      </button>
                    </li>
                    </>
                  )}
                  {isLoggedIn && <li className="nav-item">
                    <a
                      className="nav-link"
                      aria-current="page"
                      href={concatQueryParams(externalLinks.account)}
                    >
                      Perfil
                    </a>
                  </li>}
                </ul>
              </>
            )}
          </div>
        </div>
      </nav>
      {buttons && (
        <div
          className={`collapse navbar-collapse ${
            showCollapse ? "show" : "hide"
          }`}
          id="navbarTogglerCM"
        >
          <div className="welcome" onClick={() => Cookies.getJSON('user') && goTo(concatQueryParams(externalLinks.account))}>
            <div className="row">
              <div className="avatar">
                <img src={avatarProfile} alt="" />
              </div>
              <div className="data">
                <p className="hi">Bienvenido {Cookies.getJSON('user') ? Cookies.getJSON('user')?.name?.first : ''}</p>
                <p className="email">{!Cookies.get('user') ? 'Ingresa a tu cuenta' : Cookies.getJSON('email') || Cookies.getJSON('user').email}</p>
              </div>
            </div>
            {!user && (
              <div className="buttons">
                <button onClick={() => modalSetOpen(true)} className="btn-primary">Ingresar</button>
              </div>
            )}
          </div>
          <hr />
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <img src={lotsIcon} alt="lots menu" />
              <a
                className="nav-link"
                aria-current="page"
                href={concatQueryParams(externalLinks.lots)}
              >
                Lotes
              </a>
            </li>
            <li className="nav-item">
              <img src={sellIcon} alt="lots menu" />
              <Link className="nav-link" aria-current="page" to="/venta">
                Publicar
              </Link>
            </li>
            <li className="nav-item">
              <img src={blogIcon} alt="lots menu" />
              <a
                className="nav-link"
                aria-current="page"
                href={concatQueryParams(externalLinks.blog)}
              >
                Blog
              </a>
            </li>
            {isLoggedIn &&
            <li className="nav-item">
              <img src={profileIcon} alt="profile menu" />
              <a
                className="nav-link"
                aria-current="page"
                href={concatQueryParams(externalLinks.account)}
              >
                Perfil
              </a>
            </li>}
          </ul>
          <hr />
        </div>
      )}
    </>
  );
};

export default NavBar;
